import { useEffect, useRef, useState } from 'react';

/** Classe CSS aplicada só depois que o JS confirma que vai animar o elemento.
 *  Por isso o estado "escondido" nunca é o padrão do CSS: se o observer nunca
 *  disparar (JS desabilitado, erro, `IntersectionObserver` ausente), o
 *  elemento fica com a classe base de sempre — visível — em vez de preso em
 *  opacidade zero. */
function useReveal({ once = true } = {}) {
  const ref = useRef(null);
  const [armado, setArmado] = useState(false);
  const [visivel, setVisivel] = useState(false);

  useEffect(() => {
    const alvo = ref.current;
    if (!alvo || typeof IntersectionObserver === 'undefined') return undefined;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return undefined;
    }

    setArmado(true);

    const observador = new IntersectionObserver(
      ([entrada]) => {
        if (entrada.isIntersecting) {
          setVisivel(true);
          if (once) observador.disconnect();
        } else if (!once) {
          setVisivel(false);
        }
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' },
    );

    observador.observe(alvo);
    return () => observador.disconnect();
  }, [once]);

  const className = armado ? `reveal${visivel ? ' reveal-in' : ''}` : '';

  return [ref, className];
}

export default useReveal;
